export class GalleryPicturesModel {
    //PicId	PetNo	DateTaken	PicPath	ParentPicId	PicType	EmpNo	ZoomPct	image_id	PicNote	EmpNo	image_bidata
    PicId: number;
    PetNo: number;
    DateTaken: Date;
    PicPath: string;
    ParentPicId: number;
    PicType: string;
    EmpNo: number;
    ZoomPct: number;
    image_id: number;
    PicNote: string;
    image_bidata: string;
    username: string;

    constructor(
        PicId: number,
        PetNo: number,
        DateTaken: Date,
        PicPath: string,
        ParentPicId: number,
        PicType: string,
        EmpNo: number,
        ZoomPct: number,
        image_id: number,
        PicNote: string,
        image_bidata: string, 
        username: string
    ) {
        this.PicId = PicId;
        this.PetNo = PetNo;
        this.DateTaken = DateTaken;
        this.PicPath = PicPath;
        this.ParentPicId = ParentPicId;
        this.PicType = PicType;
        this.EmpNo = EmpNo;
        this.ZoomPct = ZoomPct;
        this.image_id = image_id;
        this.PicNote = PicNote;
        this.image_bidata = image_bidata; 
        this.username = username;
    }
}